import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'

export type OrderShortlistFeedbackEntry = {
  shortlistId: number
  rank: number
  total: number
  accepted: boolean | null
  submittedAt: string
  contactName: string | null
}

export type OrderShortlistFeedback = {
  applicantId: number
  rank: number
  accepted: boolean | null
  shortlistId: number
  total: number
  comment: string | null
  submittedAt: string
  contactName: string | null
  feedbacks: OrderShortlistFeedbackEntry[]
}

export const orderShortlistFeedbacksQueryKey = (orderId?: number) => [
  'orders',
  orderId,
  'shortlist-feedbacks'
]

const useOrderShortlistFeedbacks = (orderId?: number) =>
  useQuery<OrderShortlistFeedback[]>({
    queryKey: orderShortlistFeedbacksQueryKey(orderId),
    queryFn: ({ signal }) =>
      fetchApiWithToken<OrderShortlistFeedback[]>({
        url: `/v1/orders/${orderId}/shortlist_feedbacks`,
        signal
      }),
    enabled: !!orderId
  })

export const useApplicantShortlistFeedback = (
  orderId: number | undefined,
  applicantId: number | undefined
) =>
  useOrderShortlistFeedbacks(orderId).data?.find(
    (feedback) => feedback.applicantId === applicantId
  )
